import { c as _c } from "react/compiler-runtime";
import { useParams } from "next/navigation";
import { startTransition, useActionState } from "react";
import { type OppfolgingsplanFormUnderArbeid, oppfolgingsplanFormUnderArbeidSchema } from "@/schema/oppfolgingsplanForm/formValidationSchemas";
import { lagreUtkastServerAction } from "@/server/actions/lagreUtkast";
import type { FetchResultError } from "@/server/tokenXFetch/FetchResult";
export interface LagreUtkastActionState {
  error: FetchResultError | null;
  sistLagretTidspunkt: string | null;
  sistLagretUtkast: OppfolgingsplanFormUnderArbeid | null;
}
export default function useOppfolgingsplanUtkastLagring(t0) {
  const $ = _c(10);
  const {
    initialFormValues,
    initialSistLagretTidspunkt
  } = t0;
  const {
    narmesteLederId
  } = useParams();
  let t1;
  if ($[0] !== initialFormValues || $[1] !== initialSistLagretTidspunkt) {
    t1 = {
      error: null,
      sistLagretTidspunkt: initialSistLagretTidspunkt,
      sistLagretUtkast: initialFormValues
    };
    $[0] = initialFormValues;
    $[1] = initialSistLagretTidspunkt;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const initialLagreUtkastState = t1;
  const [t2, lagreUtkastIfChangesAction, isSavingUtkast] = useActionState(lagreUtkastIfChangesInnerAction, initialLagreUtkastState);
  const {
    error: lagreUtkastError,
    sistLagretTidspunkt
  } = t2;
  async function lagreUtkastIfChangesInnerAction(previousState, t3) {
    const {
      values,
      onSuccess,
      skipIfInvalid
    } = t3;
    const hasValuesChangedFromPreviousSave = !areFormStateObjectsEqual(values, previousState.sistLagretUtkast);
    let newActionState;
    if (hasValuesChangedFromPreviousSave) {
      if (skipIfInvalid === true) {
        const {
          success: isValid
        } = oppfolgingsplanFormUnderArbeidSchema.safeParse(values);
        if (!isValid) {
          return previousState;
        }
      }
      const result = await lagreUtkastServerAction(narmesteLederId, values);
      if (result.error) {
        newActionState = {
          sistLagretUtkast: previousState.sistLagretUtkast,
          sistLagretTidspunkt: previousState.sistLagretTidspunkt,
          error: result.error
        };
      } else {
        newActionState = {
          sistLagretUtkast: values,
          sistLagretTidspunkt: result.data.sistLagretTidspunkt,
          error: null
        };
      }
    } else {
      newActionState = {
        ...previousState
      };
    }
    if (newActionState.error === null) {
      onSuccess?.();
    }
    return newActionState;
  }
  let t4;
  if ($[3] !== lagreUtkastIfChangesAction) {
    t4 = function startLagreUtkastIfChanges(t5) {
      const {
        values: values_0,
        onSuccess: onSuccess_0,
        skipIfInvalid: skipIfInvalid_0
      } = t5;
      startTransition(() => {
        lagreUtkastIfChangesAction({
          values: values_0,
          onSuccess: onSuccess_0,
          skipIfInvalid: skipIfInvalid_0
        });
      });
    };
    $[3] = lagreUtkastIfChangesAction;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const startLagreUtkastIfChanges = t4;
  let t5;
  if ($[5] !== isSavingUtkast || $[6] !== lagreUtkastError || $[7] !== sistLagretTidspunkt || $[8] !== startLagreUtkastIfChanges) {
    t5 = {
      isSavingUtkast,
      lagreUtkastError,
      sistLagretTidspunkt,
      startLagreUtkastIfChanges
    };
    $[5] = isSavingUtkast;
    $[6] = lagreUtkastError;
    $[7] = sistLagretTidspunkt;
    $[8] = startLagreUtkastIfChanges;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
type FormFieldValue = OppfolgingsplanFormUnderArbeid[keyof OppfolgingsplanFormUnderArbeid];
function areFormStateObjectsEqual(a: Record<string, FormFieldValue> | null, b: Record<string, FormFieldValue> | null): boolean {
  if (!a || !b) return false;
  const aKeys = Object.keys(a);
  if (aKeys.length !== Object.keys(b).length) return false;
  for (const key of aKeys) {
    if (!Object.hasOwn(b, key)) return false;
    const av = a[key];
    const bv = b[key];
    if (!Object.is(av, bv)) return false;
  }
  return true;
}